module.exports = __webpack_public_path__ + "static/media/SpartanMB-Black.cf96159f.ttf";